import Vue from 'vue';
import * as types from './mutation-types';
import { compileAsyncMutations } from '@/utils/async';

// Will be default export
const mutations = {

  [types.SET_COMPANY](state, data) {
    if (data === null) {
      Vue.set(state, 'company', null);
    } else {
      const company = Object.assign({}, state.company || {});
      Object.keys(data).forEach((key) => {
        company[key] = data[key];
      });
      Vue.set(state, 'company', company);
    }
  },

  [types.SET_SEND_USER_EMAIL_LOADING](state, data) {
    Vue.set(state, 'sendUserEmailLoading', !!data);
  },

};

// For each async mutations, dynamically add three mutations
// See @/utils/async for more details
compileAsyncMutations(mutations, types);

export default mutations;
